{
  "common": {
    "cancel": "キャンセル",
    "save": "保存",
    "delete": "削除",
    "done": "完了",
    "edit": "編集",
    "search": "検索",
    "loading": "読み込み中…",
    "yes": "はい",
    "no": "いいえ",
    "settings": "設定",
    "back": "戻る",
    "close": "閉じる",
    "open": "開く",
    "copy": "コピー",
    "restore": "復元",
    "untitled": "無題",
    "create": "作成",
    "revoke": "取り消し",
    "never": "なし",
    "tryAgain": "もう一度",
    "reload": "再読み込み",
    "update": "更新",
    "insert": "挿入",
    "loadingShort": "読み込み中",
    "unknown": "不明",
    "sampleSentence": "いろはにほへと ちりぬるを"
  },
  "sidebar": {
    "views": "表示",
    "tags": "タグ",
    "edit": "編集",
    "done": "完了",
    "account": "アカウント",
    "newNote": "新規ノート",
    "editTag": "タグを編集",
    "tagOptions": "タグのオプション",
    "reorder": "{{label}}を並べ替え",
    "showView": "{{label}}を表示",
    "hideView": "{{label}}を非表示",
    "editViews": "表示を編集",
    "doneEditingViews": "編集を完了",
    "samplePeep": "Caliu とは…",
    "sampleQuiet": "思考が生きて呼吸できる静かな場所。"
  },
  "views": {
    "all": "すべてのノート",
    "today": "今日",
    "todo": "タスク",
    "pinned": "ピン留め",
    "untagged": "タグなし",
    "thisWeek": "今週",
    "shared": "自分が共有",
    "sharedWithMe": "自分と共有",
    "attachments": "添付ファイル",
    "trash": "ゴミ箱",
    "archive": "アーカイブ"
  },
  "noteList": {
    "empty": "ノートがありません",
    "emptySubtitle": "最初のノートを作成して始めましょう。",
    "untitled": "無題",
    "selectNote": "ノートを選択",
    "selectNoteHint": "リストからノートを選ぶか、新規作成してください。",
    "selectRestoreOrDelete": "ノートを選んで復元または完全に削除します",
    "selectSharedToView": "共有ノートを選んで表示します",
    "searchPlaceholder": "ノートを検索…",
    "selectNotes": "ノートを選択",
    "openSidebar": "サイドバーを開く",
    "cancelSelection": "選択をキャンセル",
    "clearSelection": "選択をクリア",
    "emptyTrash": "ゴミ箱を空にする",
    "newNote": "新規ノート",
    "noteCount_one": "{{count}}件のノート",
    "noteCount_other": "{{count}}件のノート",
    "sortBy": "並び替え",
    "preview": "プレビュー",
    "modificationDate": "更新日",
    "creationDate": "作成日",
    "title": "タイトル",
    "manual": "手動",
    "newestOnTop": "新しい順",
    "small": "小",
    "medium": "中",
    "large": "大",
    "empty_pinned": "ピン留めされたノートはありません",
    "empty_pinned_subtitle": "ピン留めするとここで素早く見つけられます。",
    "empty_today": "今日は何も編集していません",
    "empty_today_subtitle": "今日編集したノートがここに表示されます。",
    "empty_todo": "タスクはありません",
    "empty_todo_subtitle": "未完了のタスクがあるノートがここに表示されます。",
    "empty_untagged": "すべてにタグが付いています",
    "empty_untagged_subtitle": "タグなしのノートがここに表示されます。",
    "empty_thisWeek": "今週は何もありません",
    "empty_thisWeek_subtitle": "過去7日間に編集したノートがここに表示されます。",
    "empty_shared": "共有ノートはありません",
    "empty_shared_subtitle": "共有したノートがここに表示されます。",
    "empty_attachments": "添付ファイルはありません",
    "empty_attachments_subtitle": "画像やファイル付きのノートがここに表示されます。",
    "justNow": "たった今",
    "minutesAgo": "{{count}}分前",
    "today": "今日",
    "yesterday": "昨日",
    "deletedOn": "{{date}}に削除",
    "newNoteShortcut": "新規ノート ({{shortcut}})",
    "noContent": "内容なし",
    "selectUnarchiveOrDelete": "アーカイブ解除または削除するノートを選択してください",
    "view": "表示",
    "density": "密度",
    "exportAll": "すべてエクスポート"
  },
  "editor": {
    "attachmentTooLarge": "このファイルは大きすぎて添付できません。上限は 100 MB です。",
    "placeholder": "書き始めましょう…",
    "noMatchingCommands": "一致するコマンドはありません",
    "newNote": "新規ノート",
    "noResults": "結果がありません",
    "foldSection": "セクションを折りたたむ",
    "unfoldSection": "セクションを展開する",
    "dragSection": "セクションを移動する",
    "presenceLabel": "ほかに参加中: {{names}}"
  },
  "noteActions": {
    "pin": "ピン留め",
    "unpin": "ピン留めを解除",
    "pinToTop": "一番上にピン留め",
    "makeReadOnly": "読み取り専用にする",
    "makeEditable": "編集可能にする",
    "readOnlyNote": "読み取り専用のノート",
    "shareNote": "ノートを共有",
    "share": "共有",
    "publiclyShared": "公開で共有中",
    "privateNote": "プライベートノート",
    "linkCreated": "リンクを作成しました",
    "linkCreatedAndCopied": "リンクを作成してコピーしました",
    "linkRevoked": "共有リンクを取り消しました",
    "failedToCreateShareLink": "共有リンクを作成できませんでした",
    "failedToRevokeShareLink": "共有リンクを取り消せませんでした",
    "thisNoteIsPrivate": "このノートはプライベートです。",
    "createPublicLink": "公開リンクを作成",
    "creatingLink": "リンクを作成中…",
    "revokeLink": "リンクを取り消す",
    "revokingLink": "取り消し中…",
    "copyLink": "リンクをコピー",
    "copyNoteId": "ノートIDをコピー",
    "noteIdCopied": "ノートIDをコピーしました",
    "exportAs": "エクスポート形式",
    "exportMarkdown": "Markdown",
    "exportPlainText": "プレーンテキスト",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "エクスポートに失敗しました",
    "viewHistory": "履歴を表示",
    "duplicate": "複製",
    "duplicateFailed": "ノートを複製できませんでした",
    "select": "選択",
    "delete": "削除",
    "moveToTrash": "ゴミ箱へ移動",
    "archive": "アーカイブ",
    "unarchive": "アーカイブ解除",
    "tags": "タグ",
    "addTag": "タグを追加",
    "noTagsYet": "タグはまだありません",
    "addTagFailed": "タグを追加できませんでした",
    "removeTagFailed": "タグを削除できませんでした"
  },
  "userMenu": {
    "theme": "テーマ",
    "typography": "タイポグラフィ",
    "language": "言語",
    "apiKeys": "APIキー",
    "devices": "デバイス",
    "connectedApps": "接続済みアプリ",
    "help": "ヘルプ",
    "logOut": "ログアウト",
    "defaultUserName": "Caliu ユーザー",
    "editName": "名前を編集",
    "nameLabel": "名前",
    "namePlaceholder": "あなたの名前",
    "upgradeToPro": "Caliu Pro にアップグレード",
    "replayOnboarding": "オンボーディングをやり直す",
    "logOutTitle": "ログアウトしますか？",
    "logOutBody": "ノートはこのデバイスに残り、引き続き読み書きできます。同期するにはもう一度サインインしてください。",
    "logOutPending_one": "未同期の変更が {{count}} 件あります。次にサインインするまでこのデバイスに残ります。",
    "logOutPending_other": "未同期の変更が {{count}} 件あります。次にサインインするまでこのデバイスに残ります。",
    "logOutKeep": "ログアウト",
    "logOutAndRemove": "ログアウトしてノートを削除"
  },
  "help": {
    "title": "ヘルプセンター",
    "searchPlaceholder": "ヘルプ記事を検索",
    "noResults": "検索に一致する記事はありません。",
    "offline": "オフラインではヘルプを利用できません。次回接続時に読み込まれます。"
  },
  "fonts": {
    "uiFont": "UIフォント",
    "body": "本文",
    "headings": "見出し",
    "code": "コード",
    "sans": "サンセリフ",
    "serif": "セリフ",
    "mono": "等幅",
    "editor": "エディタ",
    "ui": "UI",
    "reset": "初期設定に戻す"
  },
  "themes": {
    "light": "ライト",
    "dark": "ダーク",
    "system": "システム"
  },
  "languages": {
    "systemHint": "デバイスから検出",
    "names": {
      "en": "英語",
      "es": "スペイン語",
      "ca": "カタルーニャ語",
      "fr": "フランス語",
      "de": "ドイツ語",
      "it": "イタリア語",
      "pt": "ポルトガル語",
      "nl": "オランダ語",
      "ja": "日本語",
      "zh-CN": "中国語(簡体字)",
      "ko": "韓国語",
      "zh-TW": "中国語(繁体字)",
      "ru": "ロシア語"
    }
  },
  "bulkActions": {
    "pinSelected": "選択をピン留め",
    "unpinSelected": "選択のピン留めを解除",
    "pin": "ピン留め",
    "addTag": "タグを追加",
    "filterTags": "タグを絞り込み…",
    "noTagsFound": "タグが見つかりません",
    "exportSelected": "選択をエクスポート",
    "restoreSelected": "選択を復元",
    "deletePermanently": "完全に削除",
    "moveToTrash": "ゴミ箱へ移動",
    "archiveSelected": "選択をアーカイブ",
    "unarchiveSelected": "選択のアーカイブを解除",
    "exportingTitle": "ノートを書き出しています",
    "exportingBody": "少し時間がかかることがあります。完了するまでこのタブを開いたままにしてください。",
    "exportingProgress": "{{done}} / {{total}}"
  },
  "commandPalette": {
    "placeholder": "ノート、タグ、コマンドを検索…",
    "noResults": "「{{query}}」の結果はありません",
    "currentNote": "現在のノート",
    "navigation": "ナビゲーション",
    "notes": "ノート",
    "tags": "タグ",
    "newNote": "新規ノート",
    "allNotes": "すべてのノート",
    "todaysNotes": "今日のノート",
    "todo": "タスク",
    "pinnedNotes": "ピン留めノート",
    "trash": "ゴミ箱",
    "importNotes": "ノートをインポート",
    "changeTheme": "テーマを変更",
    "keyboardShortcuts": "キーボードショートカット",
    "pinNote": "ノートをピン留め",
    "unpinNote": "ピン留めを解除",
    "restoreNote": "ノートを復元",
    "copyShareLink": "共有リンクをコピー",
    "makePrivate": "プライベートにする",
    "toggleFullscreen": "全画面を切り替え",
    "noteInfo": "ノート情報",
    "moveToTrash": "ゴミ箱へ移動",
    "archiveNote": "ノートをアーカイブ",
    "unarchiveNote": "ノートのアーカイブを解除",
    "archive": "アーカイブ"
  },
  "noteHistory": {
    "title": "ノートの履歴",
    "requiresConnection": "履歴を表示するには接続が必要です。",
    "reconnect": "インターネットに再接続してもう一度お試しください。",
    "noHistory": "このノートにはまだ履歴がありません。",
    "windowMerged": "5分以内の編集はひとつのエントリにまとめられます。",
    "selectVersion": "プレビューするバージョンを選択",
    "encrypted": "暗号化されたバージョン",
    "encryptedHint": "このバージョンはエンドツーエンド暗号化で保存されています。現在の内容を見るにはノートを開いてください。",
    "restoreVersion": "このバージョンを復元しますか？",
    "restoreVersionHint": "ノートの現在の内容を{{date}}のバージョンで置き換えます。",
    "current": "現在",
    "created": "作成",
    "trashed": "ゴミ箱に移動",
    "restored": "復元",
    "edited": "編集"
  },
  "apiKeys": {
    "title": "APIキー",
    "empty": "APIキーはまだありません。",
    "emptyHint": "APIを使うには作成してください。",
    "created": "{{date}}に作成",
    "lastUsed": "最終使用: {{date}}",
    "revokeKey": "キーを取り消す",
    "viewApiDocs": "APIドキュメントを見る",
    "newApiKey": "新しいAPIキー",
    "apiKeyCreated": "APIキーを作成しました",
    "createApiKey": "APIキーを作成",
    "copyHint": "このキーを今すぐコピーしてください。もう一度表示することはできません。",
    "copyToClipboard": "クリップボードにコピー",
    "keyName": "キー名",
    "keyNamePlaceholder": "例: マイスクリプト、Zapier 連携",
    "createKey": "キーを作成",
    "revokeKeyTitle": "APIキーを取り消す",
    "revokeKeyHint": "このAPIキーを完全に取り消します。これを使用しているアプリケーションはすぐにアクセスを失います。",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "接続済みアプリ",
    "empty": "接続済みアプリはまだありません。",
    "emptyHint": "Claude、ChatGPT、またはその他のAIアシスタントを接続すると、チャットからノートを使えます。方法はヘルプの「Caliu と AI」セクションをご覧ください。",
    "connected": "{{date}}に接続",
    "lastUsed": "最終使用: {{date}}",
    "revoke": "取り消し",
    "revokeTitle": "接続を取り消し",
    "revokeHint": "<strong>{{name}}</strong>のCaliuアカウントへのアクセスを取り消し、使用していた認証情報を削除します。すぐにアクセスを失います。",
    "thisApp": "このアプリ",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "ライティング",
    "metadata": "メタデータ",
    "words": "単語",
    "characters": "文字数",
    "paragraphs": "段落",
    "readTime": "読了時間",
    "minutes": "{{count}}分",
    "tags": "タグ",
    "outgoingLinks": "外部リンク",
    "backlinks": "被リンク",
    "created": "作成日",
    "modified": "更新日",
    "noteStatistics": "ノートの統計",
    "identifier": "識別子"
  },
  "inspector": {
    "tabInfo": "情報",
    "tabOutline": "アウトライン",
    "tabHistory": "履歴",
    "dates": "日付",
    "noHeadings": "このノートに見出しはありません",
    "noBacklinks": "このノートへのリンクはありません",
    "noOutgoing": "このノートはどこにもリンクしていません",
    "noAttachments": "このノートに添付ファイルはありません",
    "historyOffline": "バージョン履歴を表示するには接続が必要です",
    "historyLoadMore": "さらに読み込む"
  },
  "devices": {
    "title": "デバイス",
    "offline": "オフラインです。",
    "offlineHint": "インターネットに接続してデバイスを確認してください。",
    "noSessions": "アクティブなセッションが見つかりません。",
    "thisDevice": "このデバイス",
    "lastUsed": "最終使用: {{date}}",
    "created": "作成日: {{date}}",
    "signOutCurrent": "このデバイスからサインアウト",
    "signOut": "サインアウト",
    "confirmCurrentTitle": "このデバイスからサインアウトしますか？",
    "confirmRevokeTitle": "デバイスを取り消しますか？",
    "confirmCurrentBody": "このブラウザで Caliu からサインアウトし、ノートはこのデバイスから削除されます。いつでも再度サインインすれば、アカウントから戻ります。",
    "confirmRevokeBody": "デバイスは即座にサインアウトされます。同期されていない変更は、再度サインインするまでそこに残ります。",
    "revoke": "取り消す"
  },
  "errorScreen": {
    "title": "問題が発生しました",
    "defaultMessage": "予期しないエラーが発生しました。ページを再読み込みしてみてください。"
  },
  "importModal": {
    "title": "ノートをインポート",
    "dropToImport": "ドロップしてインポート",
    "dropOrClick": "ファイルをドロップするか、クリックして参照",
    "removeFile": "ファイルを削除",
    "keepNote": "Google Keep の場合は Takeout の ZIP をエクスポートし、そのアーカイブを直接アップロードしてください。",
    "importedCount_one": "<strong>{{count}}</strong> 件のノートをインポートしました",
    "importedCount_other": "<strong>{{count}}</strong> 件のノートをインポートしました",
    "fromSource": "（{{source}} から）",
    "importing": "インポート中…",
    "importN": "{{count}} 件のファイルをインポート",
    "importBtn": "インポート"
  },
  "share": {
    "shareNote": "ノートを共有",
    "publiclySharedAria": "ノートは公開共有されています",
    "copyLink": "リンクをコピー",
    "revokingLink": "取り消し中…",
    "revokeLink": "リンクを取り消す",
    "creatingLink": "リンクを作成中…",
    "createPublicLink": "公開リンクを作成",
    "shareThisNotePublicly": "このノートを公開する",
    "thisNoteIsPrivate": "このノートは非公開です。",
    "publiclyShared": "公開共有中",
    "privateNote": "非公開ノート"
  },
  "shortcuts": {
    "searchPlaceholder": "ショートカットを検索…",
    "pressNew": "新しいショートカットを押してください…",
    "resetToDefault": "デフォルトに戻す",
    "noMatches": "「<strong>{{query}}</strong>」に一致するショートカットはありません",
    "navigate": "移動",
    "edit": "編集",
    "closeAction": "閉じる",
    "resetAll": "すべてリセット"
  },
  "tagEditor": {
    "icon": "アイコン",
    "color": "色",
    "searchIcons": "アイコンを検索",
    "noIcons": "一致するアイコンはありません",
    "categories": {
      "essentials": "基本",
      "work": "仕事とテクノロジー",
      "ideas": "アイデアと創作",
      "life": "人と暮らし",
      "travel": "旅行と自然",
      "fun": "食事、健康、遊び"
    }
  },
  "tagActions": {
    "pin": "タグをピン留め",
    "unpin": "タグのピン留めを解除",
    "rename": "名前を変更…",
    "renameTitle": "タグの名前を変更",
    "renameConfirm": "変更",
    "renameHint": "タグは、アーカイブやゴミ箱のノートを含め、使用しているすべてのノートで更新されます。",
    "renamed": "タグの名前を変更しました",
    "nameInUse": "その名前はすでに使われています",
    "invalidName": "タグ名に使えるのは文字、数字、スペース、ハイフン、アンダースコアのみです",
    "pinFailed": "タグを更新できませんでした",
    "renameFailed": "タグの名前を変更できませんでした",
    "editAppearance": "外観を編集"
  },
  "auth": {
    "appName": "Caliu",
    "or": "または",
    "email": "メール",
    "emailPlaceholder": "you@example.com",
    "password": "パスワード",
    "passwordPlaceholder": "パスワード",
    "name": "名前",
    "namePlaceholder": "お名前",
    "confirmPassword": "パスワード（確認）",
    "newPassword": "新しいパスワード",
    "confirmNewPassword": "新しいパスワード（確認）",
    "signInSubtitle": "アカウントにサインイン",
    "createAccountSubtitle": "アカウントを作成",
    "forgotPassword": "パスワードをお忘れですか？",
    "signingIn": "サインイン中…",
    "signIn": "サインイン",
    "noAccount": "アカウントをお持ちでないですか？",
    "signUp": "登録",
    "haveAccount": "すでにアカウントをお持ちですか？",
    "creatingAccount": "アカウントを作成中…",
    "createAccount": "アカウントを作成",
    "googleSignUpAria": "Google で登録",
    "signupClosedTitle": "現在、新規登録は受け付けていません",
    "signupClosedBody": "Caliu はプライベートベータ中です。caliuapp.com のウェイトリストに登録すると、早期アクセスを取得できます。",
    "joinWaitlist": "ウェイトリストに参加",
    "forgotTitle": "パスワードをリセット",
    "forgotSubtitle": "メールアドレスを入力すると、リセットリンクをお送りします。",
    "sendResetLink": "リセットリンクを送信",
    "sending": "送信中…",
    "checkYourEmail": "メールを確認",
    "resetLinkSentPrefix": "もし ",
    "resetLinkSentSuffix": " のアカウントが存在する場合、パスワードリセットのリンクを送信しました。1時間で期限切れになります。",
    "backToSignIn": "サインインに戻る",
    "verifySentPrefix": "確認リンクを ",
    "verifySentSuffix": " に送信しました。クリックしてアカウントを有効化してください。",
    "linkExpires10m": "リンクは 10 分で期限切れになります。",
    "resending": "再送信中…",
    "resendEmail": "メールを再送信",
    "wrongEmail": "メールアドレスが違いますか？",
    "goBack": "戻る",
    "invalidResetLinkTitle": "無効なリセットリンク",
    "invalidResetLinkBody": "このリンクは無効か期限切れです。",
    "requestNewLink": "新しいリンクをリクエスト",
    "setNewPasswordTitle": "新しいパスワードを設定",
    "setNewPasswordHint": "強いパスワードを選んでください。",
    "updatingPassword": "更新中…",
    "updatePassword": "パスワードを更新",
    "localNotesTitle": "このデバイスにノートがあります",
    "localNotesBody_one": "サインイン前にこのデバイスで{{count}}件のノートを書きました。どうしますか？",
    "localNotesBody_other": "サインイン前にこのデバイスで{{count}}件のノートを書きました。どうしますか？",
    "localNotesDelete": "削除する",
    "localNotesMerge": "アカウントに追加する",
    "backToMyNotes": "ノートに戻る",
    "errorGoogleAuthFailed": "Googleでのサインインに失敗しました。もう一度お試しください。",
    "errorInvalidToken": "確認リンクが無効です。もう一度登録してください。",
    "errorEmailTaken": "このメールアドレスはすでに使用されています。サインインしてください。",
    "signInInstead": "そのアカウントでサインインする",
    "errorIdentityTaken": "このサインイン方法はすでに別のCaliuアカウントに紐づいています。そのアカウントにサインインしてください。",
    "parkedNotesTitle": "別のアカウントのノート",
    "parkedNotesBody_one": "{{email}} にサインインすると、そのアカウントのノートをこのデバイスに残せます。別のアカウントでサインインすると、その後に書いたものも含めて、ここにあるノート1件が削除されます。",
    "parkedNotesBody_other": "{{email}} にサインインすると、そのアカウントのノートをこのデバイスに残せます。別のアカウントでサインインすると、その後に書いたものも含めて、ここにあるノート{{count}}件がすべて削除されます。",
    "parkedNotesBodyNoEmail_one": "サインアウトしたアカウントにサインインすると、そのアカウントのノートをこのデバイスに残せます。別のアカウントでサインインすると、その後に書いたものも含めて、ここにあるノート1件が削除されます。",
    "parkedNotesBodyNoEmail_other": "サインアウトしたアカウントにサインインすると、そのアカウントのノートをこのデバイスに残せます。別のアカウントでサインインすると、その後に書いたものも含めて、ここにあるノート{{count}}件がすべて削除されます。",
    "parkedNotesContinue": "続ける"
  },
  "connectors": {
    "wantsAccess": "は Caliu へのアクセスを求めています",
    "couldntLoad": "このリクエストを読み込めませんでした",
    "authorize": "認可",
    "keepHappeningHint": "これが続く場合は、MCP クライアントからコネクタを削除して再度追加してください。",
    "backToCaliu": "Caliu に戻る",
    "askingPermissionPrefix": " は、Caliu の MCP サーバーを介してノートとタグの読み取りと変更の許可を求めています。",
    "signedInAs": "{{name}} としてサインイン中。",
    "permissions": "権限",
    "deny": "拒否",
    "allow": "許可"
  },
  "editorTypography": {
    "fontSize": "フォントサイズ",
    "lineHeight": "行の高さ",
    "paragraphSpacing": "段落間隔"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Shift"
  },
  "floatingMenu": {
    "undo": "元に戻す",
    "redo": "やり直す",
    "taskList": "タスクリスト",
    "bulletList": "箇条書き",
    "orderedList": "番号付きリスト",
    "blockQuote": "引用ブロック",
    "separator": "区切り線",
    "insertTag": "タグを挿入",
    "highlight": "ハイライト",
    "math": "数式",
    "removeHighlight": "ハイライトを削除",
    "inlineCode": "インラインコード",
    "codeBlock": "コードブロック",
    "insertTable": "テーブルを挿入",
    "insertImage": "画像を挿入",
    "hideStyleBar": "スタイルバーを非表示",
    "attachFile": "ファイルを添付",
    "photoLibrary": "写真ライブラリ",
    "camera": "カメラ",
    "fromFile": "ファイルから"
  },
  "imageDialog": {
    "title": "画像を挿入",
    "tabUpload": "ファイル",
    "tabUrl": "URL",
    "urlLabel": "画像 URL",
    "urlPlaceholder": "https://example.com/image.jpg",
    "altLabel": "代替テキスト",
    "altPlaceholder": "画像を説明…",
    "previewAlt": "プレビュー",
    "changeImage": "画像を変更",
    "dropToInsert": "ドロップして挿入",
    "dropOrClick": "画像をドロップするか、クリックして参照",
    "formats": "PNG、JPG、GIF、WebP",
    "insert": "画像を挿入"
  },
  "linkDialog": {
    "editTitle": "リンクを編集",
    "insertTitle": "リンクを挿入",
    "textLabel": "テキスト",
    "textPlaceholder": "リンクのテキスト",
    "urlPlaceholder": "https://example.com",
    "removeLink": "リンクを削除",
    "openLink": "リンクを開く",
    "editLink": "リンクを編集"
  },
  "noteEditor": {
    "notFound": "ノートが見つかりません。",
    "inTrashBanner": "このノートはゴミ箱にあります。編集するには復元してください。",
    "restore": "復元",
    "noContent": "このノートには内容がありません。"
  },
  "noteHeader": {
    "noteInfo": "ノート情報"
  },
  "table": {
    "deleteRow": "行を削除",
    "deleteTable": "テーブルを削除",
    "addRow": "行を追加",
    "addRowAbove": "上に行を追加",
    "addColumn": "列を追加",
    "addColumnBefore": "前に列を追加",
    "moveRowUp": "行を上に移動",
    "moveRowDown": "行を下に移動",
    "moveColumnLeft": "列を左に移動",
    "moveColumnRight": "列を右に移動",
    "deleteColumn": "列を削除",
    "actions": "表の操作"
  },
  "syncIndicator": {
    "synced": "同期済み",
    "pending_one": "{{count}} 件の同期待ち",
    "pending_other": "{{count}} 件の同期待ち",
    "offline": "オフライン",
    "offlinePending_one": "オフライン · {{count}} 件待機中",
    "offlinePending_other": "オフライン · {{count}} 件待機中",
    "syncing": "同期中...",
    "conflict_one": "{{count}} 件の競合",
    "conflict_other": "{{count}} 件の競合",
    "error": "同期エラー",
    "syncedTooltip": "すべての変更を保存しました",
    "pendingTooltip_one": "{{count}} 件の変更が同期待ちです",
    "pendingTooltip_other": "{{count}} 件の変更が同期待ちです",
    "offlineTooltip": "オフライン: 再接続時に変更が同期されます",
    "offlinePendingTooltip_one": "オフライン: 再接続時に {{count}} 件の変更が同期されます",
    "offlinePendingTooltip_other": "オフライン: 再接続時に {{count}} 件の変更が同期されます",
    "syncingTooltip": "同期中...",
    "syncingPendingTooltip_one": "{{count}} 件の変更を同期中...",
    "syncingPendingTooltip_other": "{{count}} 件の変更を同期中...",
    "conflictTooltip_one": "{{count}} 件のノートに競合する変更があります。クリックして解決してください。",
    "conflictTooltip_other": "{{count}} 件のノートに競合する変更があります。クリックして解決してください。",
    "errorTooltip": "同期に失敗しました。自動的に再試行します。",
    "conflictsTitle": "競合を解決",
    "local": "このデバイス",
    "localTooltip": "このデバイスのみに保存されています。同期するにはサインインしてください。"
  },
  "image": {
    "download": "画像をダウンロード",
    "replace": "画像を置き換え",
    "remove": "画像を削除"
  },
  "sharePage": {
    "goToCaliu": "Caliu へ",
    "noteNotFoundTitle": "ノートが見つかりません",
    "somethingWentWrong": "問題が発生しました",
    "lastUpdated": "最終更新: {{date}}",
    "tagline": "思考する人のためのノートアプリ",
    "subtagline": "Markdown で書く。どこでも同期。すっきり思考。",
    "startWriting": "書き始める",
    "signIn": "サインイン",
    "openInCaliu": "Caliu で開く",
    "adding": "追加中…",
    "addToSharedList": "共有リストに追加",
    "notFoundSubtitle": "この共有リンクは期限切れか取り消されている可能性があります。",
    "errorSubtitle": "このノートを読み込めません。もう一度お試しください。"
  },
  "sharedView": {
    "loading": "共有ノートを読み込み中…",
    "sharedWithYou": "あなたと共有されています",
    "viewRaw": "Markdownのソースを表示",
    "viewRendered": "整形表示に戻す",
    "copyMarkdown": "Markdownをコピー",
    "markdownCopied": "Markdownをコピーしました",
    "copyFailed": "コピーに失敗しました",
    "notLoadedYet": "このノートはまだ読み込まれていません",
    "linkCopied": "リンクをコピーしました",
    "actions": "ノートの操作"
  },
  "sharedWithMe": {
    "title": "自分と共有",
    "removeFromList": "リストから削除",
    "empty": "まだ共有ノートはありません",
    "emptyHint": "友達からの Caliu の共有リンクを開くとここに追加されます。共有ノートはすべてのデバイスで同期されます。"
  },
  "trashView": {
    "empty": "ゴミ箱は空です",
    "emptyHint": "削除されたノートはここに表示されます",
    "retention": "ゴミ箱内のノートは 30 日後に完全に削除されます",
    "trash": "ゴミ箱"
  },
  "fileAttachment": {
    "download": "ファイルをダウンロード",
    "remove": "ファイルを削除"
  },
  "archiveView": {
    "archive": "アーカイブ",
    "empty": "アーカイブは空です",
    "emptyHint": "アーカイブしたノートがここに表示されます",
    "archivedOn": "{{date}} にアーカイブ"
  },
  "pro": {
    "subtitle": "Caliu を、すべて解き放つ。",
    "features": [
      "ノート無制限",
      "ノートのバージョン履歴",
      "PDF・HTML・RTF・ePub + 一括書き出し",
      "すべてのテーマ、フォント、アプリアイコン",
      "Caliu の開発を支えます"
    ],
    "perMonth": "月額{{price}}",
    "perWeek": "週額{{price}}",
    "oneTime": "買い切り{{price}}",
    "perYear": "年額{{price}}",
    "or": "または",
    "signInToSubscribe": "ログインして購読",
    "accountRequired": "Caliu Pro はアカウントに紐づくため、すべての端末で利用できます。",
    "plansUnavailable": "プランを読み込めませんでした。接続を確認してもう一度お試しください。",
    "yearly": "年額",
    "monthly": "月額",
    "continue": "続ける",
    "bestValue": "おすすめ",
    "autoRenew": "{{amount}}。解約するまで自動更新されます。いつでも解約できます。",
    "freeTrial": "{{count}}日間無料",
    "billedSubtitle": "{{count}}日間無料、その後は{{amount}}。いつでも解約できます。",
    "startTrial": "無料トライアルを始める",
    "upgradeSubtitle": "バージョン履歴、すべてのテーマとフォント、エクスポートなど。",
    "upgradeNow": "今すぐアップグレード",
    "thanks": "Caliu を応援いただきありがとうございます！",
    "renewsOn": "{{date}} に更新",
    "endsOn": "{{date}} に終了",
    "lifetime": "ライフタイムアクセス",
    "lifetimePlan": "買い切り",
    "oneTimeNoRenewal": "一回限りのお支払い",
    "launchPrice": "発売記念価格です。今後 {{price}} に値上げされます。",
    "buy": "購入",
    "oneTimeDisclosure": "{{amount}}。一回限りのお支払い、更新なし。",
    "thanksMessage": "あなたの応援が、Caliu の独立性とプライバシーを守っています。",
    "manageSubscription": "サブスクリプションを管理",
    "contactUs": "ご質問は？お問い合わせ",
    "grandfatheredNote": "早期サポーターとして、Caliu Pro は生涯あなたのものです。更新は不要です。",
    "webFootnote": "PDF 書き出しは、ウェブではまだ利用できません。",
    "active": "有効"
  },
  "find": {
    "placeholder": "ノート内を検索",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "結果なし",
    "next": "次の一致",
    "previous": "前の一致",
    "close": "閉じる"
  },
  "conflicts": {
    "description": "このノートは別のデバイスで編集されました。どちらかのバージョンを選んでください。",
    "yours": "自分のバージョン",
    "theirs": "相手のバージョン",
    "step": "{{total}} 件中 {{current}} 件目",
    "keepYours": "自分のを保持",
    "keepTheirs": "相手のを保持",
    "serverError": "別のバージョンを読み込めませんでした。",
    "done": "すべての競合が解決しました。",
    "previous": "前の競合",
    "next": "次の競合",
    "copyOf": "{{title}} のコピー"
  },
  "onboarding": {
    "welcomeTitle": "Caliuへようこそ",
    "welcomeSubtitle": "思考が静かに息づく、ささやかな場所。",
    "getStarted": "始める",
    "magicTitle": "言葉が形になっていく",
    "magicSubtitle": "書くのはただのテキスト。Caliuがタスク、ハイライト、タグへと自動で整えます。",
    "magicLearnMore": "Markdownの基本を学ぶ",
    "replay": "もう一度見る",
    "demoTitle": "海辺の夏",
    "demoBody": "小さな町で**ゆっくりした一週間**を過ごす計画。",
    "demoTask": "小さな家を予約する",
    "demoHighlight": "朝食==前==にひと泳ぎ",
    "demoTags": "#夏 #計画",
    "intentTitle": "ここに何を持ち込みますか？",
    "intentSubtitle": "いくつか選んでください。最初のノートとタグが、あなたを待っています。",
    "themeTitle": "あなたの灯りを選ぶ",
    "themeSubtitle": "書く気分にあわせて選べるテーマ。",
    "proTitle": "最初からすべてを",
    "proSubtitle": "初日からすべてを使い始めましょう。まずは無料で試して、価値があると思えたら続けてください。",
    "proTrust": "広告なし。仕掛けなし。いつでも解約できます。",
    "tryProFree": "Proを無料で試す",
    "continueFree": "無料プランで続ける",
    "allSetTitle": "準備完了です",
    "allSetSubtitle": "Caliuへようこそ。あなた色に染めてください。",
    "startWriting": "書き始める",
    "firstNoteTitle": "ここから始まる",
    "firstNoteBody": "これは私の最初のノート。この端末に保存され、オフラインでも動き、どこへでもついてくる。",
    "firstNoteTask": "残しておきたい考えをひとつ書く",
    "next": "次へ",
    "skip": "スキップ",
    "back": "戻る",
    "intents": {
      "journal": "日記",
      "ideas": "アイデア",
      "work": "仕事",
      "study": "勉強",
      "reading": "読書",
      "plans": "計画"
    },
    "signInCta": "ログインまたは新規登録",
    "continueWithoutAccount": "アカウントなしで続ける",
    "backupTitle": "ノートの保存場所",
    "backupSubtitle": "ノートはこのデバイスから始まります。アカウントがあれば同期され、安全なコピーがすべてのデバイスに届きます。",
    "syncOffTitle": "同期はオフです",
    "syncOffBody": "サインインすると、すべてのデバイスでノートを同期できます。",
    "backupSignedIn": "書いている間、ノートは安全に同期されます。",
    "backupStageDevice": "このデバイス",
    "backupStageSafe": "同期済み",
    "backupStageEverywhere": "すべてのデバイス",
    "freeNotes": "アカウント不要で、無料のノート{{limit}}件がずっと使えます。Proなら無制限です。"
  },
  "backup": {
    "evictionNotice": "現在、ノートはこのブラウザ内にのみ保存されています。空き容量が少なくなると、ブラウザがサイトデータを削除することがあります。",
    "dismiss": "閉じる",
    "signIn": "サインイン"
  },
  "gate": {
    "share": "サインインするとノートを共有できます。",
    "history": "サインインするとバージョン履歴を保存できます。",
    "import": "サインインするとノートをインポートできます。"
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "LaTeX ソース"
  },
  "noteLimit": {
    "banner": "{{limit}}件中{{count}}件のノート",
    "paywallTitle": "無料の{{limit}}件のノートに達しました",
    "paywallBody": "編集、検索、同期はそのまま使えます。ノートをゴミ箱に移動すると枠が空きます。Caliu Proなら無制限になります。月額、年額、または買い切りのライフタイム購入から選べます。",
    "importCapped": "{{total}}件中{{count}}件のファイルのみ読み込みました。無料プランでは{{limit}}件までノートを作成できます。"
  },
  "appUpdate": {
    "available": "Caliu の新しいバージョンが利用できます。"
  },
  "settings": {
    "title": "設定",
    "account": "アカウント",
    "writing": "執筆",
    "keyboardShortcuts": "キーボードショートカット",
    "editor": "エディタ",
    "yourNotes": "ノート",
    "about": "このAppについて",
    "noAccount": "アカウントなし",
    "sendFeedback": "フィードバックを送信",
    "signInOrCreate": "ログインまたは新規登録",
    "notesComeWithYou": "この端末のノートはそのまま引き継がれます。",
    "notSyncing": "同期していません",
    "signInToSync": "サインインするとノートを同期できます。",
    "sync": "同期",
    "security": "セキュリティ",
    "communications": "お知らせ",
    "newsletter": "Caliu ニュースレター",
    "newsletterFooter": "新しいリリースや Caliu にこれから届く機能について、ときどき短いメールをお届けします。",
    "newsletterError": "ニュースレターの設定を更新できませんでした。もう一度お試しください。",
    "appearance": "外観",
    "themes": "テーマ",
    "sizing": "サイズ",
    "systemDefault": "システムのデフォルト",
    "separateThemes": "ライトとダークで別のテーマ",
    "maxWidth": "最大幅",
    "maxWidthHint": "幅の広い画面でテキストを読みやすい段に中央揃えします",
    "markdownReturn": "MarkdownスタイルのReturn",
    "markdownReturnHint": "Returnで改行します。段落を変えるにはReturnを2回押します",
    "newNoteStart": "新規メモの書き出し",
    "newNoteStartH1": "見出し 1",
    "newNoteStartH2": "見出し 2",
    "newNoteStartH3": "見出し 3",
    "newNoteStartH4": "見出し 4",
    "newNoteStartDate": "日付",
    "newNoteStartDateIso": "日付（ISO 8601）",
    "newNoteStartDateTime": "日付と時刻",
    "newNoteStartDateTimeIso": "日付と時刻（ISO 8601）",
    "newNoteStartEmpty": "空白",
    "newNoteStartHint": "アプリで作成するメモに適用されます。",
    "collapsibleSections": "折りたたみ可能なセクション",
    "collapsibleSectionsHint": "見出しとその内容をシェブロンで折りたたためるようにします",
    "experimental": "実験的機能",
    "general": "一般"
  },
  "toolbar": {
    "toggleSidebar": "サイドバーの表示/非表示",
    "toggleInspector": "インスペクタの表示切り替え",
    "searchNotes": "ノートを検索",
    "newNote": "新しいノート",
    "findInNote": "ノート内を検索",
    "showToolbar": "ツールバーを表示",
    "hideToolbar": "ツールバーを隠す",
    "moreNoteActions": "ノートのその他の操作",
    "undo": "取り消す",
    "redo": "やり直し",
    "zenMode": "Zenモード",
    "sourceMode": "ソースモード",
    "richEditor": "リッチエディタ",
    "sortBy": "並べ替え",
    "bold": "太字",
    "italic": "斜体",
    "heading": "見出し",
    "list": "リスト",
    "link": "リンク",
    "insert": "挿入",
    "more": "その他",
    "strikethrough": "取り消し線",
    "table": "表",
    "horizontalRule": "区切り線",
    "codeBlock": "コードブロック",
    "inlineCode": "インラインコード",
    "blockQuote": "引用",
    "math": "数式",
    "highlight": "ハイライト",
    "bulletList": "箇条書きリスト",
    "orderedList": "番号付きリスト",
    "photoLibrary": "写真",
    "camera": "カメラ",
    "files": "ファイル",
    "yellow": "黄",
    "green": "緑",
    "blue": "青",
    "pink": "ピンク",
    "purple": "紫",
    "heading1": "見出し 1",
    "heading2": "見出し 2",
    "heading3": "見出し 3",
    "heading4": "見出し 4",
    "heading5": "見出し 5",
    "heading6": "見出し 6",
    "removeHighlight": "ハイライトを削除"
  },
  "whatsNew": {
    "title": "新機能",
    "tagIconsTitle": "Caliuのために描いたアイコン",
    "tagIconsBody": "アプリのアイコンはすべて新しく、Caliuのためにデザインしました。タグごとにアイコンを設定でき、日本語でも検索できます。",
    "newNoteStartTitle": "ノートの書き出しを自由に",
    "newNoteStartBody": "新しいノートを、見出し、今日の日付、日付と時刻、または空白のページで始められます。「設定」の「エディタ」で選べます。",
    "typographyTitle": "文字を、正確な数値で",
    "typographyBody": "ノートの文字サイズ、行の高さ、段落の間隔を正確な値で選べます。「設定」の「タイポグラフィ」から。",
    "typographySample": "どのノートも、設定した文字サイズ、行の高さ、間隔に1ポイント単位で従います。",
    "sampleMorningPages": "モーニングページ",
    "newsletterTitle": "Caliu ニュースレターを始めました",
    "newsletterBody": "これからは、リリースごとの新機能を短いメールでお知らせします。お使いの言語でお届けします。ご希望の場合はオンにしてください。設定からいつでも変更できます。"
  },
  "sharing": {
    "inviteByEmail": "メールで招待",
    "invite": "招待",
    "roleOwner": "オーナー",
    "roleEditor": "編集可",
    "roleViewer": "閲覧可",
    "generalAccess": "一般アクセス",
    "shareWithLink": "リンクで共有",
    "accessRestricted": "招待した人のみ",
    "accessView": "リンクを知っている全員が閲覧可",
    "accessEdit": "リンクを知っている全員が編集可",
    "remove": "削除",
    "leave": "退出",
    "leaveNote": "ノートから退出",
    "leaveConfirmTitle": "このノートから退出しますか？",
    "leaveConfirmBody": "すべてのデバイスのリストから消えます。オーナーはあなたを再び招待できます。",
    "leaveSelectedTitle": "共有ノートから退出しますか？",
    "leaveSelectedBody_one": "あなたと共有されている{{count}}件のノートから退出します。自分のノートはゴミ箱へ移動します。",
    "leaveSelectedBody_other": "あなたと共有されている{{count}}件のノートから退出します。自分のノートはゴミ箱へ移動します。",
    "sharedBy": "{{name}} が共有",
    "sharedList": "共有済み",
    "viewOnly": "閲覧のみ",
    "accessNowEditor": "このノートを編集できるようになりました。",
    "accessNowViewer": "このノートは閲覧のみになりました。",
    "accessRemoved": "このノートにアクセスできなくなりました。",
    "unsentSavedAsCopy": "未送信の変更はコピーとして保存されました。",
    "privateNote": "非公開ノート",
    "memberLimit": "ノートは最大50人と共有できます。",
    "rateLimit": "招待が多すぎます。しばらくしてからもう一度お試しください。",
    "inviteFailed": "招待を送信できませんでした。もう一度お試しください。",
    "invalidEmail": "有効なメールアドレスを入力してください。",
    "onlineOnly": "共有を管理するにはインターネットに接続してください。",
    "you": "あなた",
    "ownerOnly": "アクセスできる人を変更できるのはオーナーだけです。",
    "unavailable": "現在、共有を利用できません。しばらくしてからもう一度お試しください。",
    "updateFailed": "共有を更新できませんでした。もう一度お試しください。",
    "inviteInvalid": "この招待は無効になりました。",
    "copyLink": "リンクをコピー",
    "invited": "招待済み",
    "copied": "コピーしました",
    "accessRestrictedHint": "招待した人だけが開けます。",
    "onlyYouHint": "開けるのはあなただけです。",
    "accessViewHint": "リンクを知っている人は誰でも読めます。アカウントは不要です。",
    "accessEditHint": "リンクを知っている人は誰でも編集できます。",
    "roleBelowLink": "リンクを知っている人は誰でも編集できるため、招待した人も編集できます。",
    "inviteAs": "招待時の権限",
    "revokeInvite": "招待を取り消す",
    "statusPeople_one": "{{count}}人",
    "statusPeople_other": "{{count}}人",
    "publicLink": "公開リンク",
    "statusFrom": "{{name}}さんから",
    "removeConfirmTitle": "{{name}} を削除しますか？",
    "removeConfirmBody": "このノートにアクセスできなくなります。",
    "revokeConfirmTitle": "{{name}} への招待を取り消しますか？",
    "revokeConfirmBody": "招待リンクは使えなくなります。",
    "peopleWithAccess": "アクセスできるメンバー",
    "addPeoplePlaceholder": "メールでメンバーを追加",
    "invitePro": "メンバーの招待は Caliu Pro の機能です。",
    "inviteKeepsAccess": "リンクをオフにしても、招待した人はアクセスを保持します。",
    "youSuffix": "（あなた）"
  },
  "noAccess": {
    "title": "このノートへのアクセス権がありません",
    "linkBody": "所有者はこのノートをあなたと共有していません。招待するか、リンクをオンにするよう依頼してください。",
    "signedOutBody": "共有されたアカウントでサインインしてください。",
    "inviteTitle": "この招待は無効になりました",
    "inviteBody": "招待した人に新しい招待を依頼してください。",
    "removedTitle": "このノートにアクセスできなくなりました",
    "removedBody": "所有者があなたを削除しました。",
    "removedCopyBody": "所有者があなたを削除しました。未送信の変更はコピーとしてノートに保存されました。",
    "backToNotes": "ノートに戻る",
    "signIn": "サインイン"
  }
}
